@if (parts()[0] === '') {
    <div
        *transloco="let t"
        [class]="
            'bazis-vehicle-number bazis-vehicle-number--disabled bazis-vehicle-number_' +
            regionSuffix()
        "
    >
        <span class="bazis-vehicle-number__noparts">
            {{ t('title.noVehicleNumber') }}
        </span>
        <span class="bazis-vehicle-number__part bazis-vehicle-number__part_3">---</span>
    </div>
} @else {
    <div [class]="'bazis-vehicle-number bazis-vehicle-number_' + regionSuffix()">
        @for (part of parts(); let i = $index; track $index) {
            <span
                class="bazis-vehicle-number__part"
                [ngClass]="['bazis-vehicle-number__part_' + i]"
                >{{ part }}</span
            >
        }
    </div>
}
